import React from "react";

export const CalendarIcon = (props) => {
    return (
        <svg width="48" height="48" fill="currentColor" viewBox="0 0 16 16" {...props}>
            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
        </svg>
    );
};

export const VoltIcon = (props) => {
    return (
        <svg width="48" height="48" fill="currentColor" viewBox="0 0 16 16" {...props}>
            <path d="M11.251.068a.5.5 0 0 1 .227.58L9.677 6.5H13a.5.5 0 0 1 .364.843l-8 8.5a.5.5 0 0 1-.842-.49L6.323 9.5H3a.5.5 0 0 1-.364-.843l8-8.5a.5.5 0 0 1 .615-.09z" />
        </svg>
    );
};

export const ExpandIcon = (props) => {
    return (
        <svg width="48" height="48" fill="currentColor" viewBox="0 0 24 24" {...props}>
            <g data-name="Layer 2">
                <path
                    d="M20 5a1 1 0 0 0-1-1h-5a1 1 0 0 0 0 2h2.57l-3.28 3.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L18 7.42V10a1 1 0 0 0 1 1 1 1 0 0 0 1-1zm-9.29 8.29a1 1 0 0 0-1.42 0L6 16.57V14a1 1 0 0 0-1-1 1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2H7.42l3.29-3.29a1 1 0 0 0 0-1.42z"
                    data-name="expand"
                />
            </g>
        </svg>
    );
};

export const Chevron = ({ direction = "right", ...props }) => {
    let d;
    switch (direction) {
        case "left":
            d = "M15 19l-7-7 7-7";
            break;
        case "right":
        default:
            d = "M9 5l7 7-7 7";
    }
    return (
        <svg {...props} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={d} />
        </svg>
    );
};

export const ImagesIcon = (props) => {
    return (
        <svg width="48" height="48" fill="currentColor" viewBox="0 0 16 16" {...props}>
            <path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
            <path d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2zM14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1zM2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1h-10z" />
        </svg>
    );
};

export const CloseIcon = (props) => {
    return <i className="far fa-times"></i>;
};

export const WarningIcon = (props) => {
    return <i className="far fa-triangle-exclamation"></i>;
};

export const AlertIcon = (props) => {
    return <i className="far fa-bell-on"></i>;
};

export const SuccessIcon = (props) => {
    return <i className="fas fa-check"></i>;
};

export const LoaderIcon = (props) => {
    return (
        <svg width="48" height="48" fill="currentColor" viewBox="0 0 20 20" {...props}>
            <path d="M10 3.5A6.5 6.5 0 0 0 3.5 10 .75.75 0 0 1 2 10a8 8 0 1 1 8 8 .75.75 0 0 1 0-1.5 6.5 6.5 0 1 0 0-13z" />
        </svg>
    );
};
